import axios from "axios";
import config from "@/lib/config";
import { getAuthToken } from "@/lib/authStorage";

export const login = async (identifier, password) => {
  try {
    const response = await axios.post(`${config.loginUrl}/auth/login`, {
      identifier,
      password,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const checkUsername = async (username) => {
  try {
    const response = await axios.get(
      `${config.loginUrl}/users/check-username`,
      {
        params: { username },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const checkEmail = async (email) => {
  try {
    const response = await axios.get(`${config.loginUrl}/users/check-email`, {
      params: { email },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createUser = async (user) => {
  try {
    const response = await axios.post(`${config.loginUrl}/users/create`, user);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updatePassword = async (currentPassword, newPassword) => {
  try {
    const token = getAuthToken();
    const response = await axios.put(
      `${config.loginUrl}/auth/update-password`,
      { currentPassword, newPassword },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const recoverPassword = async (token, newPassword) => {
  try {
    const response = await axios.post(
      `${config.loginUrl}/auth/recover-password`,
      {
        token,
        newPassword,
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const quickRegister = async ({ username, password, name, email, phoneNumber }) => {
  try {
    const response = await axios.post(
      `${config.loginUrl}/auth/quick-register`,
      { username, password, name, email, phoneNumber }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};